(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  const syncKranTeamQuoteFields = (quote) => {
    const salutation = quote.querySelector('[data-kt-quote-salutation]');
    const person = quote.querySelector('[data-kt-quote-person]');
    if (!salutation || !person) return;

    const isCompany = salutation.value === 'Firma';
    person.hidden = isCompany;
    person.querySelectorAll('input').forEach((input) => { input.disabled = isCompany; });
  };

  const initKranTeamQuote = () => {
    document.querySelectorAll('[data-kt-cart-quote]').forEach(syncKranTeamQuoteFields);
    const quote = document.getElementById('KranTeamQuoteRequest');
    if (quote && new URLSearchParams(window.location.search).get('angebot') === '1') {
      quote.open = true;
      window.requestAnimationFrame(() => quote.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  };

  // Athens can retain the footer's `is-empty` class after a cart update even
  // though line items are present. That class hides checkout and the inquiry
  // button completely, so resync it from the rendered cart on page load.
  const syncKranTeamCartFooter = () => {
    const footer = document.getElementById('main-cart-footer');
    const hasItems = document.querySelector('.main-cart-items .js-cart-item') !== null;
    if (footer && hasItems) footer.classList.remove('is-empty');
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-kt-quote-salutation]')) return;
    syncKranTeamQuoteFields(event.target.closest('[data-kt-cart-quote]'));
  });

  document.addEventListener('kt:submitted', (event) => {
    if (!event.target.matches('[data-kt-brevo-form]')) return;
    syncKranTeamQuoteFields(event.target.closest('[data-kt-cart-quote]'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initKranTeamQuote();
      syncKranTeamCartFooter();
    });
  } else {
    initKranTeamQuote();
    syncKranTeamCartFooter();
  }

  } catch(e) { console.error(e); }
})();
})();
